import $ from 'jquery'

$(document).on('click', '.showMore_button', function () {
  $(this).parents('.toggledBlock').toggleClass('opened')
  $(this).prev('.toggledBody').slideToggle()
  $(this).parent('div').prev('.toggledBody').slideToggle()

})
